import { NoiseGenerator } from './noise';
import { SEA_LEVEL } from '@shared/chunk-constants';

export function getHeight(noise: NoiseGenerator, wx: number, wz: number): number {
  // Continental noise - large scale features
  const continental = noise.octave2D(wx, wz, 4, 0.5, 2.0, 0.002);

  // Erosion noise - medium scale
  const erosion = noise.octave2D(wx + 1000, wz + 1000, 3, 0.5, 2.0, 0.008);

  // Detail noise - small features
  const detail = noise.octave2D(wx + 5000, wz + 5000, 2, 0.5, 2.0, 0.03);

  // Combine: base height + continental + erosion detail
  const baseHeight = SEA_LEVEL + 4;
  const continentalHeight = continental * 30;
  const erosionHeight = erosion * 12;
  const detailHeight = detail * 4;

  const height = baseHeight + continentalHeight + erosionHeight + detailHeight;

  return Math.floor(Math.max(1, Math.min(200, height)));
}

export function getTemperature(noise: NoiseGenerator, wx: number, wz: number): number {
  return noise.octave2D(wx + 3000, wz + 3000, 2, 0.5, 2.0, 0.001) * 0.5 + 0.5;
}

export function getHumidity(noise: NoiseGenerator, wx: number, wz: number): number {
  return noise.octave2D(wx + 7000, wz + 7000, 2, 0.5, 2.0, 0.0015) * 0.5 + 0.5;
}
